import { render, staticRenderFns } from "./PreviewPDF.vue?vue&type=template&id=2b3993ea&scoped=true"
import script from "./PreviewPDF.vue?vue&type=script&lang=js"
export * from "./PreviewPDF.vue?vue&type=script&lang=js"
import style0 from "./PreviewPDF.vue?vue&type=style&index=0&id=2b3993ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3993ea",
  null
  
)

export default component.exports